import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import prop from '../config'
import sumut from './theme-sumut'
import collega from './theme-default'
import sulteng from './theme-sulteng'
import bkl from './theme-bkl'
import sulut from './theme-sulut'

Vue.use(Vuetify)
export default new Vuetify({
  iconfont: 'mdi',
  options: {
    customProperties: true,
  },
  theme :{
    themes: {
      light: {
        primary: 
          prop.profile === 'SUMUT' ? 
            sumut.primary :
          prop.profile === 'SULTENG' ? 
            sulteng.primary :
          prop.profile === 'SULUT' ?
            sulut.primary :
          prop.profile === 'BENGKULU' ? 
            bkl.primary :
            collega.primary,
        secondary: 
          prop.profile === 'SUMUT' ? 
            sumut.secondary :
          prop.profile === 'SULTENG' ? 
            sulteng.secondary :
          prop.profile === 'SULUT' ?
            sulut.secondary :
          prop.profile === 'BENGKULU' ? 
            bkl.secondary :
            collega.secondary,
        btnprimary: 
          prop.profile === 'SUMUT' ? 
            sumut.btnprimary :
          prop.profile === 'SULTENG' ? 
            sulteng.btnprimary :
          prop.profile === 'SULUT' ?
            sulut.btnprimary :
          prop.profile === 'BENGKULU' ? 
            bkl.btnprimary :
            collega.btnprimary,
      }
    }
  }
})